import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { Button, Col, Container, Row, Table, Input, Card, CardBody, Pagination, PaginationItem, PaginationLink, InputGroup, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { isEmpty } from "lodash"
import Flatpickr from "react-flatpickr"
import moment from 'moment';
import { Link } from "react-router-dom"
import 'flatpickr/dist/flatpickr.min.css';
import { get, update, remove } from "../../components/helpers/api_helper"
import { toast } from "react-toastify"
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { getStatusClass } from "../../components/utils/common"
import * as XLSX from "xlsx";

const Dashboard = () => {
  const dateRangeRef = useRef()
  const inputRef = useRef()
  const [data, setData] = useState({})
  const [period, setPeriod] = useState({})
  const [defaultDate, setDefaultDate] = useState([])
  const [viewRecord, setViewRecord] = useState({})
  const [modal, setModal] = useState(false);
  const [id, setId] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteEnabled, setDeleteEnabled] = useState(false)
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false)
  const [isFilterMode, setIsFilterMode] = useState(false)
  const [periodDropdown, setPeriodDropdown] = useState(false);
  const [downloadDropdown, setDownloadDropdown] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [pageSizeDropdown, setPageSizeDropdown] = useState(false);

  function toggleDelete(state = true) {
    setDeleteModal(!state)
  }

  const handleDelete = (id) => {
    setId(id)
    toggleDelete(false)
  }

  function tog_modal() {
    setModal(!modal)
  };

  const fetchData = async (url = `/form?limit=${pageSize}`) => {
    setLoading(true)
    try {
      const data = await get(url);
      setData(data);
      setNextPage(data.next);
      setPrevPage(data.previous);
      setIsFilterMode(data.isFiler)
    } catch (error) {
      toast.error("Error fetching data. Please refresh and check your connection.");
    } finally {
      setLoading(false);
    }
  };

  const loadPage = (pageUrl, newPage) => {
    if (newPage && newPage !== currentPage) {
      fetchData(pageUrl);
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (pageSize !== 15) { // Only refetch if pageSize changed from default
      fetchData();
    }
  }, [pageSize]);

  var suTo = null;

  const searchBar = (value) => {
    value = value.trim();
    if (value == '' || value.length > 1) {
      clearTimeout(suTo);
      suTo = setTimeout(() => {
        fetchData(`/form/?search=${value}&limit=${pageSize}`)
        setCurrentPage(1)
      }, 200);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setCurrentPage(1);
    fetchData(`/form?limit=${newPageSize}`);
    setPageSizeDropdown(false);
  };

  const onPeriodChange = (period) => {
    let now = moment.utc();
    let start, end;

    start = now.clone().subtract(period, 'days').format('YYYY-MM-DD');
    end = now.clone().format('YYYY-MM-DD');

    onDateRangeChange([start, end]);
    dateRangeRef.current.flatpickr.clear();
    inputRef.current.value = '';
    setPeriod({
      value: period,
      start: start,
      end: end
    });
    setDefaultDate([start, end]);
  }

  const handleClick = (obj) => {
    setViewRecord(obj)
    tog_modal()
  }

  const onDelete = async () => {
    let updatedData = [...data.results];

    try {
      const response = await remove("/form/delete", [id]);

      if (response.ok) {
        updatedData = updatedData.filter((item) => item._id !== id);
        toggleDelete()
        setDeleteEnabled(false)
        setData({ ...data, results: updatedData });
        toast.success("Record deleted successfully!");
        fetchData(`/form?page=${currentPage}&limit=${pageSize}`)
      } else {
        toast.error("Error deleting record");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const formatDateRange = (dateStrings) => {
    const dates = dateStrings?.map((dateString) => moment(dateString));
    const minDate = moment.min(dates);
    const maxDate = moment.max(dates);
    const formattedMinDate = minDate?.format('D MMMM YYYY');
    const formattedMaxDate = maxDate?.format('D MMMM YYYY');

    if (!formattedMinDate && !formattedMaxDate) {
      return "Not Available"
    } else {
      const output = `${formattedMinDate} to ${formattedMaxDate}`;
      return output;
    }
  };

  const generateExcel = () => {
    const excelData = data.results?.map((item) => ({
      "Name": item?.name,
      "Email": item?.email,
      "Mobile": item?.mobile,
      "Subject": item?.subject,
      "Status": item?.status,
      "Created At": moment(item?.date).format("MMM D, YYYY"),
      "Message": item?.comments,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);

    const columnWidths = [
      { wch: 20 },
      { wch: 32 },
      { wch: 15 },
      { wch: 25 },
      { wch: 10 },
      { wch: 13 },
      { wch: 1000 },
    ];

    ws["!cols"] = columnWidths;

    const firstRow = 2;
    const lastRow = firstRow + excelData.length - 1;

    for (let i = firstRow; i <= lastRow; i++) {
      ["A", "B", "C", "D", "E", "F", "G"].forEach((col) => {
        const cellRef = col + i;
        const cell = ws[cellRef];

        cell.s = { alignment: { vertical: 'top', horizontal: 'left' } };
      });
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, `contact_form_${moment().format("YYYY-MM-DD")}.xlsx`);
  };


  const generatePDF = () => {
    if (!data || isEmpty(data.results)) {
      const doc = new jsPDF();
      const text = 'No records found';
      const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
      const x = (doc.internal.pageSize.width - textWidth) / 2;
      const y = doc.internal.pageSize.height / 2;

      doc.setFontSize(14);
      doc.text(text, x, y);
      doc.save('empty_table.pdf');
      return;
    }

    const dateStrings = data?.results?.map((item) => item.date);
    const duration = formatDateRange(dateStrings);

    const headers = ['S.No', 'Name', 'Email', 'Mobile', 'Subject', 'Status', 'Created Date', 'Message'];
    const doc = new jsPDF('l');

    const headStyles = { fillColor: [62, 191, 238] };
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(62, 191, 238);
    doc.text('Subul Contracting', 14, 10);
    doc.setTextColor(0);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.text('Generated on: ' + moment().format('lll'), 14, 22);
    doc.text(`Duration: ${duration}`, 14, 16);

    const modifiedData = data?.results?.map((item, index) => ([
      1 + index,
      item.name,
      item.email,
      item?.mobile,
      item.subject,
      item.status,
      item?.date ? moment(item?.date).format('MMM D, YYYY') : "Not Available",
      item.comments,
    ]));

    const columnStyles = {
      0: { cellWidth: 14 },
      1: { cellWidth: 35 },
      2: { cellWidth: 57 },
      3: { cellWidth: 29 },
      4: { cellWidth: 38 },
      5: { cellWidth: 19 },
      6: { cellWidth: 26 },
      7: { cellWidth: 52 },
    };

    doc.autoTable({
      head: [headers],
      body: modifiedData,
      startY: 25,
      rowPageBreak: 'auto',
      bodyStyles: { valign: 'top' },
      columnStyles: columnStyles,
      theme: 'grid',
      headStyles,
      startY: 35,
    });

    doc.save(`contact_form_${moment().format("YYYY-MM-DD")}.pdf`);
  };

  const updateStatusById = (id, newStatus) => {
    setData(prevData => ({
      ...prevData,
      results: prevData?.results?.map(item => (
        item._id === id ? { ...item, status: newStatus } : item
      )),
    }));
  };

  const updateStatus = async (id, selectedStatus) => {
    if (!selectedStatus) {
      toast.error('Select a status before updating.');
      return;
    }

    try {
      const response = await update('/form/update', { id, status: selectedStatus })
      if (response?.ok) {
        toast.success('Status updated successfully');
        updateStatusById(id, response?.result?.status)
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const onDateRangeChange = (dateRange) => {
    if (!isEmpty(dateRange)) {
      setCurrentPage(1)
      let [start_date, end_date] = [moment(dateRange[0]), moment(dateRange[1])]
      let date_ranges = [start_date.format("YYYY-MM-DD"), end_date.format("YYYY-MM-DD")]
      setDefaultDate([date_ranges[0], date_ranges[1]])
      fetchData(`/form/filter?date=${date_ranges[0]}&date_end=${date_ranges[1]}&limit=${pageSize}`)
      setPeriod({})
      inputRef.current.value = '';
    }
  }

  const handleRefresh = () => {
    fetchData(`/form?page=${currentPage}&limit=${pageSize}`)
    dateRangeRef.current.flatpickr.clear();
    inputRef.current.value = '';
    setPeriod({})
  }

  return (
    <React.Fragment>
      <div className="page-content wrapper d-flex flex-column" style={{ marginTop: "60px", minHeight: "83vh" }}>
        <MetaTags>
          <title>Dashboard | Subul Contracting</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {/* Mobile-First Responsive Controls */}
                  <Row className="mb-3">
                    {/* Search Bar - Full width on mobile */}
                    <Col xs="12" lg="4" className="mb-2 mb-lg-0">
                      <div className="search-box">
                        <div className="position-relative">
                          <input
                            className="form-control form-control-sm"
                            type="search"
                            onInput={(e) => searchBar(e.target.value)}
                            placeholder={"Search here..."}
                            ref={inputRef}
                            style={{ height: '32px' }}
                          />
                          <i className="uil uil-search search-icon text-primary" style={{ marginTop: "2px" }}></i>
                        </div>
                      </div>
                    </Col>

                    {/* Controls - Stack on mobile, inline on larger screens */}
                    <Col xs="12" lg="8">
                      <div className="d-flex flex-column flex-md-row gap-2 justify-content-lg-end">
                        {/* First row of controls on mobile */}
                        <div className="d-flex gap-2 flex-wrap align-items-center">
                          <Dropdown isOpen={pageSizeDropdown} toggle={() => setPageSizeDropdown(!pageSizeDropdown)}>
                            <DropdownToggle caret color="info" size="sm" className="text-nowrap" style={{ height: '32px' }}>
                              Show {pageSize}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={() => handlePageSizeChange(10)} disabled={pageSize === 10}>
                                Show 10
                              </DropdownItem>
                              <DropdownItem onClick={() => handlePageSizeChange(15)} disabled={pageSize === 15}>
                                Show 15
                              </DropdownItem>
                              <DropdownItem onClick={() => handlePageSizeChange(25)} disabled={pageSize === 25}>
                                Show 25
                              </DropdownItem>
                              <DropdownItem onClick={() => handlePageSizeChange(50)} disabled={pageSize === 50}>
                                Show 50
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>

                          <Button
                            color="primary"
                            size="sm"
                            onClick={handleRefresh}
                            disabled={loading}
                            className="text-nowrap"
                            style={{ height: '32px' }}
                          >
                            Refresh
                          </Button>

                          <Dropdown isOpen={downloadDropdown} toggle={() => setDownloadDropdown(!downloadDropdown)}>
                            <DropdownToggle caret color="success" size="sm" className="text-nowrap" style={{ height: '32px' }}>
                              Download
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={generatePDF}
                                disabled={loading || !data?.results?.length}
                              >
                                Export PDF
                              </DropdownItem>
                              <DropdownItem
                                onClick={generateExcel}
                                disabled={loading || !data?.results?.length}
                              >
                                Export Excel
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </div>

                        {/* Second row of controls on mobile */}
                        <div className="d-flex gap-2 flex-wrap align-items-center">
                          <div className="flex-grow-1" style={{ minWidth: '200px', maxWidth: '250px' }}>
                            <Flatpickr
                              className="form-control form-control-sm"
                              placeholder="Select date range"
                              options={{
                                mode: "range",
                                dateFormat: "Y-m-d",
                                minDate: "2000-01",
                                maxDate: "today",
                                defaultDate: []
                              }}
                              ref={dateRangeRef}
                              value={defaultDate || []}
                              onClose={onDateRangeChange}
                              style={{ height: '32px' }}
                            />
                          </div>

                          <Dropdown isOpen={periodDropdown} toggle={() => setPeriodDropdown(!periodDropdown)}>
                            <DropdownToggle caret color="primary" size="sm" className="text-nowrap" style={{ height: '32px' }}>
                              Period
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() => onPeriodChange(30)}
                                disabled={period.value === 30}
                              >
                                Last Month
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => onPeriodChange(90)}
                                disabled={period.value === 90}
                              >
                                Last 3 Months
                              </DropdownItem>
                              <DropdownItem
                                onClick={() => onPeriodChange(180)}
                                disabled={period.value === 180}
                              >
                                Last 6 Months
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>

                          <Button
                            color="warning"
                            size="sm"
                            onClick={handleRefresh}
                            className="text-nowrap"
                            title="Clear all filters"
                            style={{ height: '32px' }}
                          >
                            Reset
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <div className="table-responsive">
                        <Table id="dashboard-table" className="table-sm">
                          <thead className="thead-light text-capitalize">
                            <tr>
                              <th>S.No</th>
                              <th>Name</th>
                              <th className="d-none d-md-table-cell">Email</th>
                              <th className="d-none d-sm-table-cell">Mobile</th>
                              <th>Subject</th>
                              <th>Status</th>
                              <th className="d-none d-lg-table-cell">Created At</th>
                              <th className="d-none d-xl-table-cell">Message</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              loading ? (
                                <tr>
                                  <td colSpan="9" className="react-bs-table-no-data" style={{ padding: "20px" }}>
                                    <p className="text-center mb-0">
                                      Fetching data... <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    </p>
                                  </td>
                                </tr>
                              ) : (
                                data?.results?.length > 0 ? (
                                  data?.results?.map((item, index) => (
                                    <tr key={index}>
                                      <td>{1 + index}</td>
                                      <td>
                                        <Link to="#" onClick={() => handleClick(item)} className="text-truncate d-inline-block" style={{ maxWidth: '120px' }}>
                                          {item.name?.substring(0, 22)}
                                        </Link>
                                      </td>
                                      <td className="d-none d-md-table-cell">
                                        <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                          {item.email?.substring(0, 30)}
                                        </span>
                                      </td>
                                      <td className="d-none d-sm-table-cell">
                                        {item?.mobile?.toString()?.slice(0, 12).replace(/^(\+)/, '\u202D$1')}
                                      </td>
                                      <td>
                                        <span className="text-truncate d-inline-block" style={{ maxWidth: '100px' }}>
                                          {item.subject?.substring(0, 20)}
                                        </span>
                                      </td>
                                      <td>
                                        <select
                                          value={item?.status}
                                          onChange={(e) => updateStatus(item?._id, e.target.value)}
                                          className="form-select form-select-sm border-0 bg-transparent p-0"
                                          style={{ fontSize: '0.875rem', minWidth: '80px' }}
                                        >
                                          <option value="pending">Pending</option>
                                          <option value="contacted">Contacted</option>
                                          <option value="resolved">Resolved</option>
                                        </select>
                                      </td>
                                      <td className="d-none d-lg-table-cell">
                                        <Link
                                          title={item?.date && moment(item?.date).format('lll')}
                                          to="#"
                                          className="text-reset"
                                        >
                                          {item?.date ? moment(item?.date).format('MMM D, YYYY') : "Not Available"}
                                        </Link>
                                      </td>
                                      <td className="d-none d-xl-table-cell">
                                        <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                          {item.comments.substring(0, 20)}
                                        </span>
                                      </td>
                                      <td>
                                        <i
                                          className="bx bx-trash-alt text-danger cursor-pointer"
                                          onClick={() => handleDelete(item._id)}
                                          style={{ fontSize: '16px' }}
                                        />
                                      </td>
                                    </tr>
                                  )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="9" className="react-bs-table-no-data" style={{ padding: "20px" }}>
                                      <p className="text-center mb-0">
                                        No records existed
                                      </p>
                                    </td>
                                  </tr>
                                )
                              )
                            }
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>

                  {/* Improved Responsive Pagination */}
                  {data?.count > 0 && (
                    <Row className="mt-3">
                      <Col xs="12">
                        {/* Pagination Info */}
                        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                          <div className="pagination-info text-muted">
                            <small>
                              Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, data?.count)} of {data?.count} entries
                              {isFilterMode && <span className="text-primary ms-1">(filtered)</span>}
                            </small>
                          </div>

                          {/* Pagination Controls */}
                          {data?.count > pageSize && (
                            <div className="d-flex justify-content-center">
                              <Pagination size="sm" className="mb-0">
                                {/* First Page */}
                                <PaginationItem disabled={currentPage === 1}>
                                  <PaginationLink
                                    first
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const endpoint = isFilterMode
                                        ? `/form/filter?page=1&date=${defaultDate[0]}&date_end=${defaultDate[1]}&limit=${pageSize}`
                                        : `/form?page=1&limit=${pageSize}`;
                                      loadPage(endpoint, 1);
                                    }}
                                    title="First Page"
                                  >
                                    <i className="bx bx-chevrons-left"></i>
                                  </PaginationLink>
                                </PaginationItem>

                                {/* Previous Page */}
                                <PaginationItem disabled={!prevPage}>
                                  <PaginationLink
                                    previous
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      loadPage(prevPage, currentPage - 1);
                                    }}
                                    title="Previous Page"
                                  >
                                    <i className="bx bx-chevron-left"></i>
                                  </PaginationLink>
                                </PaginationItem>

                                {/* Page Numbers - Responsive Logic */}
                                {(() => {
                                  const totalPages = Math.ceil(data?.count / pageSize);
                                  const isMobile = window.innerWidth <= 576;
                                  const visiblePages = isMobile ? 3 : 5;

                                  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
                                  let endPage = Math.min(startPage + visiblePages - 1, totalPages);

                                  // Adjust startPage if we're near the end
                                  if (endPage - startPage + 1 < visiblePages) {
                                    startPage = Math.max(1, endPage - visiblePages + 1);
                                  }

                                  const pages = [];

                                  // Show first page and ellipsis if needed
                                  if (startPage > 1) {
                                    pages.push(
                                      <PaginationItem key={1}>
                                        <PaginationLink
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const endpoint = isFilterMode
                                              ? `/form/filter?page=1&date=${defaultDate[0]}&date_end=${defaultDate[1]}&limit=${pageSize}`
                                              : `/form?page=1&limit=${pageSize}`;
                                            loadPage(endpoint, 1);
                                          }}
                                        >
                                          1
                                        </PaginationLink>
                                      </PaginationItem>
                                    );

                                    if (startPage > 2) {
                                      pages.push(
                                        <PaginationItem key="start-ellipsis" disabled>
                                          <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                      );
                                    }
                                  }

                                  // Show visible page numbers
                                  for (let pageNo = startPage; pageNo <= endPage; pageNo++) {
                                    if (pageNo === 1 && startPage === 1) {
                                      // Skip if we already added page 1
                                    } else {
                                      const endpoint = isFilterMode
                                        ? `/form/filter?page=${pageNo}&date=${defaultDate[0]}&date_end=${defaultDate[1]}&limit=${pageSize}`
                                        : `/form?page=${pageNo}&limit=${pageSize}`;

                                      pages.push(
                                        <PaginationItem key={pageNo} active={pageNo === currentPage}>
                                          <PaginationLink
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              loadPage(endpoint, pageNo);
                                            }}
                                          >
                                            {pageNo}
                                          </PaginationLink>
                                        </PaginationItem>
                                      );
                                    }
                                  }

                                  // Show ellipsis and last page if needed
                                  if (endPage < totalPages) {
                                    if (endPage < totalPages - 1) {
                                      pages.push(
                                        <PaginationItem key="end-ellipsis" disabled>
                                          <PaginationLink>...</PaginationLink>
                                        </PaginationItem>
                                      );
                                    }

                                    pages.push(
                                      <PaginationItem key={totalPages}>
                                        <PaginationLink
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            const endpoint = isFilterMode
                                              ? `/form/filter?page=${totalPages}&date=${defaultDate[0]}&date_end=${defaultDate[1]}&limit=${pageSize}`
                                              : `/form?page=${totalPages}&limit=${pageSize}`;
                                            loadPage(endpoint, totalPages);
                                          }}
                                        >
                                          {totalPages}
                                        </PaginationLink>
                                      </PaginationItem>
                                    );
                                  }

                                  return pages;
                                })()}

                                {/* Next Page */}
                                <PaginationItem disabled={!nextPage}>
                                  <PaginationLink
                                    next
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      loadPage(nextPage, currentPage + 1);
                                    }}
                                    title="Next Page"
                                  >
                                    <i className="bx bx-chevron-right"></i>
                                  </PaginationLink>
                                </PaginationItem>

                                {/* Last Page */}
                                <PaginationItem disabled={currentPage === Math.ceil(data?.count / pageSize)}>
                                  <PaginationLink
                                    last
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const lastPage = Math.ceil(data?.count / pageSize);
                                      const endpoint = isFilterMode
                                        ? `/form/filter?page=${lastPage}&date=${defaultDate[0]}&date_end=${defaultDate[1]}&limit=${pageSize}`
                                        : `/form?page=${lastPage}&limit=${pageSize}`;
                                      loadPage(endpoint, lastPage);
                                    }}
                                    title="Last Page"
                                  >
                                    <i className="bx bx-chevrons-right"></i>
                                  </PaginationLink>
                                </PaginationItem>
                              </Pagination>
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* View Record Modal */}
                  {modal && (
                    <Modal
                      isOpen={modal}
                      toggle={tog_modal}
                      centered
                      size="lg"
                    >
                      <ModalHeader toggle={tog_modal} className="border-bottom">
                        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
                          <span className="fw-bold">{viewRecord?.name}</span>
                          <Link
                            to="#"
                            className={`btn btn-sm ${getStatusClass(viewRecord?.status)}`}
                            title={viewRecord?.date && moment(viewRecord?.date).format('lll')}
                          >
                            {viewRecord?.status}
                          </Link>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <div className="bg-light p-4 rounded">
                          <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                              <strong>Subject:</strong> {viewRecord?.subject}
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                              <strong>Email:</strong> {viewRecord?.email}
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                              <strong>Mobile:</strong> {viewRecord?.mobile}
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                              <strong>Date:</strong> {viewRecord?.date ? moment(viewRecord?.date).format('MMM D, YYYY') : "Not Available"}
                            </div>
                            <div className="col-12">
                              <strong>Message:</strong>
                              <div className="mt-2 p-2 bg-white rounded border">
                                {viewRecord?.comments}
                              </div>
                            </div>
                          </div>
                        </div>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="secondary" onClick={tog_modal} size="sm">
                          Close
                        </Button>
                      </ModalFooter>
                    </Modal>
                  )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={deleteModal} toggle={toggleDelete} backdrop="static" centered>
        <ModalHeader toggle={toggleDelete}>
          <i className="bx bx-error-circle text-warning me-2"></i>
          Delete Confirmation
        </ModalHeader>
        <ModalBody>
          <div className="alert alert-warning">
            <h6 className="alert-heading">Warning: Before deleting this record</h6>
            <ul className="mb-3">
              <li>Once deleted, this record cannot be recovered</li>
              <li>Any data linked to this record will be permanently deleted</li>
            </ul>
            <p className="mb-0">
              Type <strong>"delete permanently"</strong> to confirm the deletion
            </p>
          </div>

          <div className="mt-3">
            <Input
              type="text"
              placeholder="Type 'delete permanently' here"
              onChange={(e) => setDeleteEnabled(e.target.value === "delete permanently")}
              className="form-control"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            size="sm"
            disabled={!deleteEnabled}
            onClick={onDelete}
          >
            <i className="bx bx-trash me-1"></i>
            Confirm Delete
          </Button>
          <Button color="secondary" size="sm" onClick={toggleDelete}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

    </React.Fragment>
  )
}

export default Dashboard